import React from 'react';
export const RulerEndMarker = ({ distanceMeasurement }) => (React.createElement("div", { className: 'ruler-end-container' },
    React.createElement("div", { className: 'ruler-label-container' },
        React.createElement("span", { className: 'distance-text' }, distanceMeasurement)),
    React.createElement("svg", { height: "60", viewBox: "0 0 24 24", className: "map_marker" },
        React.createElement("circle", { cx: "12", cy: "12", r: "2", fill: "#ffffff", stroke: "#0b6bf2", strokeWidth: "0.5" }))));
//# sourceMappingURL=RulerEndMarker.js.map